import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import Components     from './components'
import AddVehiclePage from './add-vehicle'

import component from './my-garage.component'

let module = angular.module('myGarageModule', [
  uiRouter,
  Components,
  AddVehiclePage
])

.config(($stateProvider) => {
  'ngInject'

  $stateProvider
    .state('profile.myGarage', {
      url: '/my-garage',
      params: {vin: null},
      component: 'myGaragePage',
      authenticate: true
    })
})

.component('myGaragePage', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-garage/index.js